"use client";
import { Cart } from "iconoir-react";
import { type JSX } from "react";
import { useCart } from "@/cart";
import { getCartNumberOfItems } from "../selectors";
import classNames from "classnames";

export function OpenCartButton({
  className,
  ...rest
}: Omit<JSX.IntrinsicElements["button"], "onClick">) {
  const { openCart, cart, cartDisabled } = useCart();
  const numberOfItems = getCartNumberOfItems(cart);
  if (cartDisabled === true) return null;
  return (
    <button
      onClick={openCart}
      data-item-count={numberOfItems}
      className={classNames(
        "relative flex h-8 w-8 cursor-pointer items-center justify-center self-center",
        {
          "before:absolute before:-right-2 before:bottom-0 before:flex before:h-4 before:w-4 before:items-center before:justify-center before:rounded-full before:bg-red-500 before:cvr-title-xs before:text-white before:content-[attr(data-item-count)]":
            numberOfItems > 0,
        },
        className,
      )}
      {...rest}
    >
      <span className="sr-only">{`Se handlekurv - ${numberOfItems} vare${
        numberOfItems > 1 ? "r" : ""
      }`}</span>
      <Cart width={24} height={24} />
    </button>
  );
}
